export class PoItemVariant {

    size: string;
    upc: string;
    unitPrice: string;
    currency: string;
    quantity: string;
    amount: string;
}